<template>
  <div :class="classList" :data-id="_uid" @click="toggle">
    <div class="a-label__icon" v-if="icon">
      <slot name="icon"></slot>
    </div>
    <div class="a-label__text">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-label',
  props: {
    icon: {
      type: [Boolean],
      default: false,
    },
    type: {
      type: [String],
      required: true,
    },
    size: {
      type: [String],
      default: 'small',
    },
    toggleable: {
      type: [Boolean],
      default: false,
    },
    subtype: [String],
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    classList() {
      const {
        type, subtype, size, icon, toggleable, active,
      } = this;
      return {
        'a-label': true,
        'a-label--icon': icon,
        'a-label--toggleable': toggleable,
        'a-label--active': active,
        [`a-label--${size}`]: size,
        [`a-label--${type}`]: type,
        [`a-label--${subtype}`]: subtype,
      };
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.a-label';

  $iconWidth: 26px;
  $iconWidthOutlined: 20px;

  #{$parent} {
    padding: $spacing-xs $spacing-small;
    border-radius: 4px;
    color: #fff;
    position: relative;
    width: auto;
    display: inline-block;
    font-weight: 600;
    margin-left: $spacing-xs;
    float: left;
    @include clearfix;
    &:first-child {
      margin-left: 0;
    }
    &__text {
      font-size: $font-size-xs;
      float: left;
    }
    &__icon {
      @include alignElement(false, true);
    }
    //modifiers
    &#{$parent}--toggleable {
      cursor: pointer;
    }
    &--info {
      background: $color-info;
      border-color: $color-info-dark;
      #{$parent}__icon {
        background: $color-info-dark;
      }
    }
    &--purple {
      background: $signable-secondary-1-shade-2;
      border-color: $signable-secondary-1;
      #{$parent}__icon {
        background: $signable-secondary-1;
      }
    }
    &--success {
      background: $color-success;
      border-color: $color-success-dark;
      #{$parent}__icon {
        background: $color-success-dark;
      }
    }
    &--warning {
      background: $color-warning;
      border-color: $color-warning-dark;
      #{$parent}__icon {
        background: $color-warning-dark;
      }
    }
    &--error {
      background: $color-error;
      border-color: $color-error-dark;
      #{$parent}__icon {
        background: $color-error-dark;
      }
    }
    &--outlined {
      padding: $spacing-xs;
      background: #fff;
      border-radius: 3px;
      border: 1px solid;
      #{$parent}__icon {
        width: $iconWidthOutlined;
        border-radius: 0;
        background: #fff;
        svg {
          width: 12px;
          height: 12px;
        }
      }
      &#{$parent}--icon {
        #{$parent}__text {
          margin-left: $iconWidthOutlined - $spacing-xs;
        }
      }
      &#{$parent}--purple {
        color: $signable-secondary-1;
        &:hover {
          background: $signable-secondary-1-shade-3;
        }
        &#{$parent}--active {
          background: $signable-secondary-1;
          color: #fff;
        }
      }
      &#{$parent}--info {
        color: $color-info;
      }
      &#{$parent}--success {
        color: $color-success;
      }
      &#{$parent}--warning {
        color: $color-warning;
      }
      &#{$parent}--error {
        color: $color-error;
      }
    }
    &--basic {
      padding: 0;
      background: #fff;
      border: 0;
      border-radius: 0;
      font-size: $font-size-xs;
      #{$parent}__icon {
        background: transparent;
        svg {
          height: 16px;
          width: 16px;
        }
      }
      #{$parent}__text {
        margin-left: 0;
        padding-left: $spacing-large;
      }
      &#{$parent}--info #{$parent}__icon,
      &#{$parent}--info #{$parent}__text {
        color: $color-info;
      }
      &#{$parent}--success #{$parent}__icon,
      &#{$parent}--success #{$parent}__text {
        color: $color-success;
      }
      &#{$parent}--warning #{$parent}__icon,
      &#{$parent}--warning #{$parent}__text {
        color: $color-warning;
      }
      &#{$parent}--error #{$parent}__icon,
      &#{$parent}--error #{$parent}__text {
        color: $color-error;
      }
    }
    &--draft {
      background-color: $signable-secondary-3;
    }
    &--sent {
      background-color: $signable-primary-1;
    }
    &--signed {
      background-color: $color-success;
    }
    &--rejected {
      background-color: $color-error;
    }
    &--expired {
      background-color: $signable-secondary-3-shade-2;
    }
    &--cancelled {
      background-color: $color-error-dark;
    }
    &--medium {
      padding: $spacing-xs $spacing-small;
      margin-left: $spacing-small;
      #{$parent}__text {
        font-size: 14px;
      }
    }
  }
</style>
